// ── Imports ──────────────────────────────
import React, { useState } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import Select from 'react-select';
import ErrorAlert from '../../Alerts/ErrorAlert';
import { SmartpayModulesFetchAPI } from '../../../api/SmartPay.Modules';
import './styles.css';

/* ── ICONS ── */
const IcoKey  = ()=><svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M21 2l-2 2m-7.61 7.61a5.5 5.5 0 1 1-7.778 7.778 5.5 5.5 0 0 1 7.777-7.777zm0 0L15.5 7.5m0 0l3 3L22 7l-3-3m-3.5 3.5L19 4"/></svg>;
const IcoX    = ()=><svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>;
const IcoPlus = ()=><svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>;
const IcoSave = ()=><svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><polyline points="20 6 9 17 4 12"/></svg>;
const IcoMod  = ()=><svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><rect x="3" y="3" width="7" height="7"/><rect x="14" y="3" width="7" height="7"/><rect x="14" y="14" width="7" height="7"/><rect x="3" y="14" width="7" height="7"/></svg>;

/* ════════════════════════════════════════════════════════
   COMPONENT
════════════════════════════════════════════════════════ */
function ModalAddPermissionToUserRole({ module, modulePermissions, token, role, setEventHandler }) {



  /* ════════════════════════════════════
  ════════════════════════════════════ */
  const [permission, setPermissions]         = useState([]);
  const [showModalAsing, setShowModalAsing]   = useState(false);

  const getPermissions = async () => {
    let permissionInfo = [];
    try {
      modulePermissions.forEach(permission => {
        permissionInfo.push({ value: permission.permise_id, label: permission.permission_name });
      });
      setPermissions(permissionInfo);
    } catch (err) {
      setPermissions([]);
    }
  };

  const asingSmartPayModulePermissionByUserRole = async (e) => {
    e.preventDefault();
    const form = new FormData(e.target);
    form.append('module_id', module.module_id);
    form.append('role_id', role.id);
    Object.fromEntries(form.entries());
    try {
      await SmartpayModulesFetchAPI.asingSmartpayModulePermission(form, token);
      setShowModalAsing(false);
      ErrorAlert('', 'Permiso asignado', 'success');
      setEventHandler(1);
    } catch (err) {
      ErrorAlert(err.response.data.message, 'Error de asignacion', 'warning');
    }
  };
  /* ════════════════════════════════════
     FIN LÓGICA ORIGINAL
  ════════════════════════════════════ */

  /* ══════════════════════════════════
     RENDER
  ══════════════════════════════════ */
  return (
    <>
      {/* ── TRIGGER — mismo onClick original ── */}
      <button
        className="map-trigger"
        onClick={() => { setShowModalAsing(true); getPermissions(); }}
      >
        <IcoPlus /> Asignar permiso
      </button>

      {/* ── Bootstrap Modal (importación original) ── */}
      <Modal
        show={showModalAsing}
        onHide={() => setShowModalAsing(false)}
        size="large"
        centered
        dialogClassName="map-dialog"
      >
        {/* HEADER */}
        <Modal.Header>
          <div className="map-header">
            <div className="map-header-icon"><IcoKey /></div>
            <div className="map-header-info">
              <div className="map-header-title">Asignar permiso</div>
              <div className="map-header-sub">Módulo: {module?.module_name || '—'}</div>
            </div>
            <button
              className="map-header-close"
              type="button"
              onClick={() => setShowModalAsing(false)}
            >
              <IcoX />
            </button>
          </div>
        </Modal.Header>

        {/* BODY */}
        <Modal.Body>
          <div className="map-body">

            {/* badge del módulo */}
            <div className="map-module-badge">
              <IcoMod /> {module?.module_name || 'Módulo'}
            </div>

            {/* Form — lógica original intacta */}
            <Form
              className="needs-validation"
              onSubmit={asingSmartPayModulePermissionByUserRole}
            >
              <Form.Group className="mb-3" controlId="clientId">
                <label className="map-label">Seleccione el permiso a asignar</label>
                <Select
                  className="w-100 map-select"
                  classNamePrefix="react-select"
                  options={permission}
                  name="permissionId"
                  placeholder="Buscar permiso..."
                  noOptionsMessage={() => "Sin permisos disponibles"}
                  menuPortalTarget={document.body}
                  menuPosition="fixed"
                  styles={{
                    menuPortal: base => ({ ...base, zIndex: 9999 }),
                  }}
                />
              </Form.Group>

              {/* footer dentro del form para que el submit funcione */}
              <div className="map-footer" style={{ margin: '0 -1.25rem -.95rem', padding: '.8rem 1.25rem .95rem' }}>
                <button
                  type="button"
                  className="map-btn-cancel"
                  onClick={() => setShowModalAsing(false)}
                >
                  Cancelar
                </button>
                <button type="submit" className="map-btn-save">
                  <IcoSave /> Guardar
                </button>
              </div>

            </Form>
          </div>
        </Modal.Body>

        {/* FOOTER vacío — el botón Cerrar está dentro del Form arriba */}
        <Modal.Footer style={{ display: 'none' }}>
          <Button onClick={() => setShowModalAsing(false)}>Cerrar</Button>
        </Modal.Footer>

      </Modal>
    </>
  );
}

export default ModalAddPermissionToUserRole;